import { CoreTag } from '@featuring-corp/components';
import React from 'react';

import { getCategoryTagColor } from '@utils/profileColors';

import EllipsisText from '@shared/ellipsis-text/EllipsisText';

import CoreImg from '@shared/CoreImg';

import * as styles from './blogPostContentItem.css';
import {
	getHashtagsArrayByStatus,
	getHashtagsString,
	getImageByStatus,
	getTitleByStatus,
} from './utils';

export interface BlogPostContentItemProps {
	idx?: number;
	imgSrc?: string;
	categories?: string[];
	title?: string;
	hashtags?: string[];

	isLoading?: boolean;
	isError?: boolean;
	lackOfPermission?: boolean;
}

const BlogPostContentItem = ({
	idx = 0,
	categories = [],
	isLoading,
	isError,
	lackOfPermission,
	...props
}: BlogPostContentItemProps) => {
	const status = { isLoading, isError, lackOfPermission };

	const imgSrc = getImageByStatus(props.imgSrc, idx, status);
	const title = getTitleByStatus(props.title, status);
	const hashtagsArray = getHashtagsArrayByStatus(props.hashtags, status);
	const hashtagsString = getHashtagsString(hashtagsArray);

	return (
		<div className={styles.card}>
			<div className={styles.imageBox}>
				<CoreImg
					src={imgSrc}
					alt="feed-content-image"
					is_loading={isLoading}
					object_fit="cover"
				/>
			</div>
			<div className={styles.contentBox}>
				<div className={styles.categoryBox}>
					{!isLoading &&
						categories.map((category) => (
							<CoreTag
								key={category}
								text={category}
								tagType={getCategoryTagColor(category)}
							/>
						))}
				</div>
				<EllipsisText className={styles.contentTitle} line={2}>
					{title}
				</EllipsisText>
				<EllipsisText className={styles.contentHashtags}>{hashtagsString}</EllipsisText>
			</div>
		</div>
	);
};

export default BlogPostContentItem;
